
import React from 'react';
import { Heart, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import { BUILD_YEAR } from '@/lib/buildYear';
import { currentCalendarYear } from '@/lib/calendarYear';

export const Footer: React.FC = () => {
  const currentYear = BUILD_YEAR;

  return (
    <footer className="bg-navy text-white border-t border-white/10">
      <div className="max-w-6xl mx-auto px-6 py-8">
        {/* Links row */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
          <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-white/70">
            <Link to="/planner" className="hover:text-gold transition-colors">Planner</Link>
            <Link to="/workshops" className="hover:text-gold transition-colors">Workshops</Link>
            <Link to="/dark-sky-locations" className="hover:text-gold transition-colors">Dark Sky Locations</Link>
            <Link to={`/milky-way-calendar/${currentCalendarYear()}`} className="hover:text-gold transition-colors">Milky Way Calendar</Link>
            <Link to="/about" className="hover:text-gold transition-colors">About</Link>
            <Link to="/changelog" className="hover:text-gold transition-colors">Changelog</Link>
            <Link to="/contact" className="hover:text-gold transition-colors">Contact</Link>
            <Link to="/terms" className="hover:text-gold transition-colors">Terms</Link>
            <Link to="/privacy" className="hover:text-gold transition-colors">Privacy</Link>
            <a
              href="https://milky-way-planner.getrewardful.com/signup"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gold transition-colors flex items-center gap-1"
            >
              Affiliate Program
              <ExternalLink className="w-3 h-3" />
            </a>
          </nav>
          <Link
            to="/donate"
            className="flex items-center gap-1.5 text-sm text-gold/80 hover:text-gold transition-colors whitespace-nowrap"
          >
            <Heart className="w-3.5 h-3.5 fill-current" />
            Support this project
          </Link>
        </div>

        {/* Bottom row */}
        <div className="border-t border-white/10 pt-5 flex flex-col md:flex-row justify-between items-center gap-3 text-sm text-white/60">
          <div className="flex items-center gap-1.5">
            <span>&copy; {currentYear} Milky Way Planner. Made with</span>
            <Heart className="w-3.5 h-3.5 text-red-400 fill-current" />
            <span>by{' '}
              <a
                href="https://ericbrown.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/60 hover:text-gold transition-colors"
              >
                Eric D. Brown
              </a>
            </span>
          </div>
          <nav className="flex flex-wrap justify-center gap-x-5 gap-y-1 text-white/60">
            <a
              href="https://imagesbyericbrown.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gold transition-colors flex items-center gap-1"
            >
              Photography
              <ExternalLink className="w-3 h-3" />
            </a>
            <a
              href="https://ericbrown.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gold transition-colors flex items-center gap-1"
            >
              Website
              <ExternalLink className="w-3 h-3" />
            </a>
            <a
              href="https://theworkshoplist.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gold transition-colors flex items-center gap-1"
            >
              The Workshop List
              <ExternalLink className="w-3 h-3" />
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
};
